










import { Component, Vue } from 'vue-property-decorator';
import type { Worksheet } from '@/models/worksheet';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import WorksheetAppliedLessons from '@/components/worksheets/WorksheetAppliedLessons.vue';
import { hasPermissionNavigationGuard } from '@/helpers/auth/permissionHelpers';
import { resolveLessonTypeByAppliedLessonType } from '@/helpers/resolveLessonType';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import { appliedLessonTypeFromQuery } from '@/helpers/routing/appliedLessonTypeFromQuery';

@Component({
    name: 'WorksheetView',
    components: {
        WorksheetAppliedLessons,
    },
})
export default class WorksheetView extends Vue {
    private worksheet: Partial<Worksheet> = { id: 0 };

    private onlyPR: boolean = false;

    private type: AppliedLessonType;

    private highlight: number | null;

    private mounted() {
        this.setByRoute();

        this.$watch(
            () => this.$route.query,
            () => {
                this.setByRoute();
            }
        );
    }

    private setByRoute() {
        this.worksheet.id = parseInt(this.$route.query.id as string);

        this.onlyPR = this.$route.query.onlyPR === 'true';

        this.type = appliedLessonTypeFromQuery(this.$route.query);

        this.highlight = this.$route.query.highlight ? parseInt(this.$route.query.highlight.toString()) : null;
    }
}
